<template>
  <div class="w-form">
    <form @submit.prevent="$emit('submit')">
      <slot />
    </form>
    <div v-if="error" class="w-form-fail">
      <div>{{ errorText }}</div>
    </div>
    <div v-else-if="success" class="success w-form-done">
      <div>{{ successText }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Form',
    props: {
      error: {
        type: [Boolean, String],
        default: null,
      },
      success: {
        type: [Boolean, String],
        default: null,
      },
      errorText: String,
      successText: String,
    },
  };
</script>

<style>
  .success.w-form-done, .w-form-fail {
    display: block;
    margin-bottom: 5px;
  }
</style>
